业务准入提示信息列表组件
@liwei2
<template>
  <div class="checkList-mask flex flex-middle flex-center" v-if="checkList.length>0&&isShow">
    <!-- <i class="close-btn" @click="close"></i> -->
    <div class="checkList-wrap">
      <p v-if="title" class="title">{{title}}</p>
      <p class="msg">- 请联系工作人员协助处理 -</p>
      <el-main>
        <ul>
          <li v-for="(list,key) in newCheckList" :key="key">
            <i class="icon" :class="listIcon(list.RESTRICT_TYPE)"></i>
            <div class="content-wrap">
              <span class="text-content">{{list.HANDLE_TIP}}</span>
              <p v-if="list.subList">
                <span v-for="(field ,i) in list.subList" :key="i">{{field.fieldName + '：' + field.fieldValue}}</span>
              </p>
            </div>
            <!-- <button
              @click="clickItem(list)"
              v-if="Boolean(Number(list.MENU_ID))"
            >{{list.MENU_NAME || dealButtonTxt}}</button> -->
            <button v-for="(item, index) in getMenuList(list.MENU_LIST)" :key="index" v-html="getMenuName(item)"
              @click="clickItem(item)">
            </button>
          </li>
        </ul>
      </el-main>
      <el-footer class="footer" v-if='isBizComplete'>
        <el-button id="preCheckExit" class="el-button" round @click="$emit('preCheckExit')">{{footerBtnText}}
        </el-button>
      </el-footer>
      <el-footer class="footer" v-else>
        <el-button id="preCheckBack" class="el-button" round @click="goToHome">返回首页</el-button>
        <el-button id="preCheckSkip" class="el-button" round @click="skip" v-if="!hasForbin">跳过</el-button>
        <el-button id="preCheckRetry" class="el-button" round @click="refresh" v-else>重新校验</el-button>
      </el-footer>
    </div>
  </div>
</template>

<script>
import custService from "../../service/cust-service";
import oppService from "../../service/opp-service";
export default {
  data () {
    return {
      hasForbin: false, //是否存在禁止项
      isShow: true,
      newCheckList: []
    };
  },
  props: {
    checkList: Array,
    title: {
      type: String,
      default: "账号异常"
    },
    dealButtonTxt: {
      type: String,
      default: "完善"
    },
    isBizComplete: { //父组件是否是业务完成页面
      type: Boolean,
      default: false
    },
    footerBtnText: {
      type: String,
      default: "返回"
    },
  },
  computed: {
    busiCode () {
      return this.$store.state.busicode;
    },
    isLogin () {
      return this.$store.state.isLogin;
    },
    custInfo () {
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
    },
    userType () {
      return this.$store.state.usertype;
    },
  },
  mounted () {
    this.handelWithPreCheckList();

  },
  destroyed () {
  },
  watch: {
    checkList (v) {
      this.handelWithPreCheckList();
    }
  },
  methods: {
    handelWithPreCheckList () {
      let accessDataArr = _.orderBy(this.checkList, ["RESTRICT_TYPE"], ["asc"]),
        refuseArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "0"),
        banArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "1"),
        warnArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "2"),
        remindArr = _.filter(accessDataArr, o => o.RESTRICT_TYPE == "3");

      if (refuseArr.length) {
        //有拒绝项 
        this.newCheckList = refuseArr.concat(this.clearOtherRestrictTypeMenuId([banArr, warnArr, remindArr]));
      } else if (banArr.length) {
        this.newCheckList = banArr.concat(this.clearOtherRestrictTypeMenuId([warnArr, remindArr]));
      } else if (warnArr.length) {
        this.newCheckList = warnArr.concat(this.clearOtherRestrictTypeMenuId([remindArr]));
      } else {
        this.newCheckList = remindArr;
      }

      this.newCheckList.forEach(item => {
        if (["0", "1"].indexOf(item.RESTRICT_TYPE) != -1) {
          //存在禁止项
          this.hasForbin = true;
        }
      });
    },
    clearOtherRestrictTypeMenuId (arr) {
      let arrCopy = _.cloneDeep(arr);
      _.forEach(arrCopy, function (arr2) {
        _.forEach(arr2, function (item) {
          item.MENU_ID = "";
        });
      });
      return _.flattenDeep(arrCopy);
    },
    close () {
      this.isShow = false;
      if (this.isLogin) {
        this.$router.push({ path: "/homeCustomer" });
      } else {
        this.$router.push({ path: "/home" });
      }
    },
    getMenuList (menuList) {
      return _.filter(menuList, obj => obj.MENU_ID != "");
    },
    getMenuName (menu) {
      if (["90002019", "90002020"].includes(menu.MENU_ID)) {
        if (menu.MENU_ID == "90002019") {
          return "休眠账户恢复交易";
        } else {
          return "休眠账户销户";
        }
      } else {
        return menu.MENU_NAME || this.dealButtonTxt;
      }
    },
    listIcon (listIconType) {
      switch (listIconType) {
        case "0":
          return "refuse";
        case "1":
          return "forbid";
          break;
        case "2":
          return "wran";
          break;
        case "3":
          return "normal-icon";
          break;
        default:
          return "normal-icon";
          break;
      }
    },
    goToHome () {
      if (
        this.isLogin &&
        this.busiCode != "V0009" &&
        this.custInfo.CUST_STATUS != "9"
      ) {
        //已经登录成功且不是销户状态 跳转登录后的首页
        this.$router.replace({
          path: "/homeCustomer"
        });
      } else {
        this.$router.replace({
          path: "/home"
        });
      }
    },
    skip () {
      this.$emit("skip");
    },
    refresh () {
      this.$emit("refresh");
    },
    clickItem (menu) {
      let that = this,
        custInfo = this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO);
      //修复从开户业务跳转菜单之后，业务名称为空的BUG
      menu.MENU_NAME = menu.MENU_NAME || menu.BUSI_NAME;
      if (menu.BUSI_CODE == "V0008" && menu.CON_ID == "554" && menu.MENU_ID == "90002007" && this.busiCode == "V0035") {
        return that.$syscfg.K_Request("W0000020", {
          ID_CODE: custInfo.ID_CODE,
          YZT_CHANNEL: that.getSystemParam("VTM_YZT_CHANNEL")
        }
        ).then(data => {
          if (data.Code == "0") {
            let cuacctList_ = [];
            //所有客户号的信息
            that.custInfoAllList = data.Data;
            //拼接所有的主资金账号数组
            _.forEach(data.Data, function (item) {
              let cuacctListTemp_ = _.filter(item.CUST_CUACCT_INFO, function (item1) {
                return item1.MAIN_FLAG == "1";
              });
              cuacctList_ = cuacctList_.concat(cuacctListTemp_);
            });
            //主资金账户数组对象
            that.mainCuacctListObj = _.uniqBy(cuacctList_, "CUACCT_CODE");
            //主资金账户数组
            that.cuacctList = _.pluck(that.mainCuacctListObj, "CUACCT_CODE");
            if (that.cuacctList.length > 0) {
              this.$router.replace({ name: "home", params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME, userType: "0" } });
            } else {
              this.$router.replace({ name: "home", params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME, userType: "exteral" } });
            }
          }
        }).catch(err => {
          that.alert("校验客户信息失败，请重试！");
          consoleLog(err);
          that.myLoading({
            showLoading: false
          });
        });
      }

      if (menu.IS_RECOD_CUST) {
        //调用账户系统接口L1102335留痕“已提示客户为‘失联客户’” toDo
        custService
          .W0000201({
            SPECIAL_FLAG_TYPE: "02",
            INT_ORG: custInfo.INT_ORG,
            CUST_CODE: custInfo.CUST_CODE
          })
          .then(function (flag) {
            if (flag) {

              that.goToMenu(menu);
            }
          })
          .catch(function (err) {
            that.alert(err);
          });
      } else {
        that.goToMenu(menu);
      }
    },
    //获取系统参数
    getSystemParam (parmCode) {
      return oppService.getSysCommonParamsFromCacheObjs(parmCode);
    },
    goToMenu (menu) {
      if (menu.BUSI_CODE_ACS && menu.BUSI_CODE_ACS !== "") {
        //更新业务名称和业务代码
        this.$store.commit(this.$types.UPDATE_BUSI_CODE, menu.BUSI_CODE_ACS);
        this.$storage.setSession(this.$definecfg.BUSI_NAME, menu.MENU_NAME);

        //如果是双录业务 需要保存标志
        if (
          menu.MENU_ID == "99665000" ||
          _.startsWith(menu.BUSI_CODE_ACS, "P")
        ) {
          consoleLog("保存双录标志");
          this.$storage.setSession(this.$definecfg.IS_DOUBLE_RECORD, 1);
        }

        let ps = { busiCode: menu.BUSI_CODE_ACS, userType: " " };
        if ("userType" in menu) {
          this.$store.commit(this.$types.UPDATE_USER_TYPE, this.userType);
          ps["userType"] = this.userType;
        }

        this.$router.replace({
          name: "bizInfo",
          params: ps
        });
      } else {
        //menu.MENU_ID 为将要跳转的目标菜单ID，如果没配置对应的业务代码，则跳转到他的所在的菜单页面；
        //比如该菜单属于二级菜单，则跳转secondLevelBiz，否则跳转一级菜单
        //先查下该菜单是否存在上级菜单
        menu = _.find(this.$storage.getJsonLocal(this.$definecfg.ALL_MENU), {
          MENU_ID: menu.MENU_ID
        });
        if (menu) {
          let ps = { busiCode: menu.BUSI_CODE, userType: " " };
          if (this.$syscfg.isOpenAcctBiz(this.busiCode)) {
            this.$router.replace({ name: "home", params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME, userType: "exteral" } });
          } else {
            //从[账户密码重置]业务规范性检查跳转[客户资料变更]业务
            //直接跳过密码校验环节，但需要再次进行人脸识别，识别通过后可进入业务
            if (this.busiCode == "V0005" && menu.BUSI_CODE == "V0049") {
              let that = this;
              oppService.updateSessionBusiNameAndDef("V0049").then(function (data) {
                that.$storage.removeLocal(that.$definecfg.PRE_MODULE_DATA_CACHE); //清除预录入模块配置缓存
                that.$storage.removeLocal(that.$definecfg.PRE_GROUP_DATA_CACHE); //清除预录入分组配置缓存
                that.$router.replace({ name: "readFace", params: { reReadFace: true } });
              });
            } else {
              if (this.isLogin) {
                // 客户已登录，直接进入需跳转业务的规范性检查环节
                let that = this;
                oppService.updateSessionBusiNameAndDef(menu.BUSI_CODE).then(function (data) {
                  that.$storage.removeLocal(that.$definecfg.PRE_MODULE_DATA_CACHE); //清除预录入模块配置缓存
                  that.$storage.removeLocal(that.$definecfg.PRE_GROUP_DATA_CACHE); //清除预录入分组配置缓存
                  if (that.isBizComplete) {
                    //如果是业务完成页面，直接进入业务简介
                    that.$router.replace({ name: "homeCustomer", params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME } });
                  } else {
                    that.$emit("refresh");
                  }
                });
                // this.$router.replace({ name: 'homeCustomer', params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME, userType: this.userType } });
              } else {
                // 客户未登录，如代理人登记等，需回到未登录前首页业务简介
                this.$router.replace({ name: "home", params: { busiCode: menu.BUSI_CODE, menuName: menu.MENU_NAME, userType: this.userType } });
              }
            }
          }

        } else {
          //都不存在，
          this.alert("菜单配置错误：没有子菜单或页面");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes pop {
  from {
    bottom: -100%;
  }
  to {
    bottom: 0;
  }
}
.checkList-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.7);
  .close-btn {
    position: absolute;
    top: 230px;
    right: 400px;
    display: block;
    width: 70px;
    height: 70px;
    background-size: 100% 100%;
    background-image: url("~@img/spec/00deny/icon_guanbi.png");
  }
  .checkList-wrap {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    position: absolute;
    left: 50%;
    bottom: 0;
    width: 1300px;
    height: 920px;
    padding: 0 70px;
    border-radius: 4px;
    background-color: #fff;
    transform: translateX(-50%);
    overflow-y: scroll;
    animation: pop 0.2s linear;
    img {
      width: 66px;
      height: 66px;
    }
    .title {
      padding: 50px 0 15px;
      margin: 0;
      text-align: center;
      font-size: 56px;
      color: #232323;
      font-weight: bold;
    }
    .msg {
      margin: 0;
      font-size: 25px;
      color: #81848c;
      text-align: center;
    }
    ul {
      width: 100%;
      // height: 388px;
      overflow-y: auto;
      margin: 0;
      padding: 0;
      background: #ffffff;
      border-radius: 8px;
      list-style: none;

      li {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-top: 20px;
        width: 100%;
        min-height: 110px;
        padding: 10px 30px;
        border-radius: 4px;

        font-size: 24px;
        color: #232323;
        line-height: 36px;
        background-color: #eff2f6;
        .icon {
          display: block;
          width: 65px;
          height: 34px;
          margin-right: 16px;
          background-size: 100% auto;
          background-repeat: no-repeat;
          &.forbid {
            background-image: url("~@img/spec/00deny/icon_jinzhi.png");
          }
          &.refuse {
            background-image: url("~@img/spec/00deny/icon_jujue.png");
          }
          &.wran {
            background-image: url("~@img/spec/00deny/icon_jinggao.png");
          }
        }
        .content-wrap {
          width: 814px;
          margin-right: 52px;
          text-align: left;
          .text-content {
            font-size: 25px;
            font-weight: 600;
            line-height: 1.2;
            word-break: break-all;
            span {
              display: inline-block;
              &:first-child {
                margin-right: 25px;
              }
            }
          }
        }
        button {
          width: 198px;
          height: 60px;
          border: 2px solid #1062d1;
          border-radius: 25px;
          color: #1062d1;
          font-size: 22px;
          background-color: #ffffff;
          flex: 0 0 auto;
          margin-left: 20px;
        }
      }
    }
    .footer {
      text-align: center;
      padding: 25px 0;
      height: 130px !important;
      width: 100%;
      border-top: 1px solid #d6d6d6;
      text-align: center;
      background-color: white;
      overflow: hidden;
      .el-button {
        min-width: 220px;
        width: auto;
        height: 80px;
        margin: 0 20px;
        // background: linear-gradient(45deg, #3556dd, #4667e9);
        border-radius: 4px;
        font-size: 32px;
        font-weight: 500;
        // color: #fff;
        &:first-child {
          color: #5172f6;
          background-color: #ffffff;
          box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.08);
          border: solid 2px #5172f6;
        }
        &:last-child {
          color: #fff;
          background: linear-gradient(45deg, #3556dd, #4667e9);
          &.is-disabled {
            background-color: #c0c4cc;
            box-shadow: 0px 6px 14px rgba(146, 153, 162, 0.26);
            border-color: #f5f7fa;
            background-image: linear-gradient(90deg, #ecf5ff 0%, #ecf5ff 100%);
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/common/preCheckList.vue